module.exports = __webpack_public_path__ + "media/images/emblems/Arni_bei_Biglen-coat_of_arms-4ebdf78eb11fcfc49e6a98df1a8137e6.svg";